import { MessagesApplicationsUser } from '@/dotnet-client'
import { Button } from '@fluentui/react-components'
import { Delete24Regular, Person24Regular } from '@fluentui/react-icons'
import { FluentCard } from '../FluentCard/FluentCard'

type AppAdminCardProps = {
  admin: MessagesApplicationsUser
  onDelete: () => void
}

export const AppAdminCard = (props: AppAdminCardProps) => {
  return (
    <FluentCard
      title={props.admin.givenName + ' ' + props.admin.familyName}
      //description={props.admin.}
      icon={<Person24Regular />}
      action={
        <Button
          appearance="transparent"
          icon={<Delete24Regular />}
          aria-label="More options"
          onClick={props.onDelete}
        />
      }
    />
  )
}
